import NextErrorComponent from 'next/error';
import * as React from 'react';
import { DeviceType } from '../../functions/utils/requestContextUtils';
import { IPageMetaData, IProjectMetaData } from '../../models/metaTypes';
import { GoogleAnalytics } from '../Tracking/GoogleAnalytics';
import { Tealium } from '../Tracking/Tealium';

export interface IMaxPrepsErrorComponentProps {
  projectMetaData: IProjectMetaData;
  pageMetaData: IPageMetaData;
  pageViewGuid: string;
  statusCode: number;
  title: string;
  deviceType: DeviceType;
}

const contextDataPoints = {};

const MaxPrepsErrorComponent: React.FC<IMaxPrepsErrorComponentProps> = ({
  projectMetaData,
  pageMetaData,
  pageViewGuid,
  statusCode,
  deviceType,
  title
}: IMaxPrepsErrorComponentProps) => (
  <>
    <Tealium
      projectMetaData={projectMetaData}
      pageMetaData={pageMetaData}
      deviceType={deviceType}
      pageViewGuid={pageViewGuid}
      initialStatusCode={statusCode}
      contextDataPoints={contextDataPoints}
    />
    <GoogleAnalytics
      initialStatusCode={statusCode}
      trackingPath={pageMetaData.tracking}
    />
    <NextErrorComponent statusCode={statusCode} title={title} />
  </>
);

export default Object.assign(MaxPrepsErrorComponent, {
  getInitialProps: NextErrorComponent.getInitialProps
});
